import { MessageCircle, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/lib/Logo";
import { BRAND, BRAND_SUB, PHONE_DIGITS } from "@/lib/constants";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer id="contact">
      <div className="footer-main">
        <div className="brand footer-brand">
          <LogoMark />
          <span>
            <strong>{BRAND}</strong>
            <small>{BRAND_SUB}</small>
          </span>
        </div>
        <p>{t.footer.about}</p>
        <div className="footer-actions">
          <a href={`tel:${PHONE_DIGITS}`} data-testid="footer-call-link">
            <Phone size={16} /> {t.footer.call}
          </a>
          <a href={`https://wa.me/${PHONE_DIGITS}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link">
            <MessageCircle size={16} /> {t.footer.whatsapp}
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Sudheer Kumar · {t.footer.rights}</span>
        <span>
          <a href="#privacy" data-testid="privacy-link">{t.footer.privacy}</a> · <a href="#terms" data-testid="terms-link">{t.footer.terms}</a> ·{" "}
          <a href="#cancellation" data-testid="cancellation-link">{t.footer.cancellation}</a> ·{" "}
          <Link to="/areas/igi-airport" data-testid="footer-area-igi-link">IGI Airport</Link> ·{" "}
          <Link to="/areas/yashobhoomi" data-testid="footer-area-yashobhoomi-link">Yashobhoomi</Link> ·{" "}
          <Link to="/areas/kapashera-border" data-testid="footer-area-kapashera-link">Kapashera</Link> ·{" "}
          <Link to="/admin/login" data-testid="admin-login-link">{t.footer.admin}</Link>
        </span>
      </div>
    </footer>
  );
};
